import {
  IQuestionnaire,
  IQuestionnaireItemEnableWhenAttachmentComponent,
  IQuestionnaireItemEnableWhenBooleanComponent,
  IQuestionnaireItemEnableWhenCodingComponent,
  IQuestionnaireItemEnableWhenDateComponent,
  IQuestionnaireItemEnableWhenDateTimeComponent,
  IQuestionnaireItemEnableWhenDecimalComponent,
  IQuestionnaireItemEnableWhenHasAnswerComponent,
  IQuestionnaireItemEnableWhenIntegerComponent,
  IQuestionnaireItemEnableWhenQuantityComponent,
  IQuestionnaireItemEnableWhenReferenceComponent,
  IQuestionnaireItemEnableWhenStringComponent,
  IQuestionnaireItemEnableWhenTimeComponent,
  IQuestionnaireItemEnableWhenUriComponent,
  IQuestionnaireItemGroupComponent,
  IQuestionnaireItemOptionCodingComponent,
  IQuestionnaireItemOptionDateComponent,
  IQuestionnaireItemOptionIntegerComponent,
  IQuestionnaireItemOptionStringComponent,
  IQuestionnaireItemOptionTimeComponent,
  IQuestionnaireItemTableGroupComponent,
  QuestionnaireItemComponent,
  QuestionnaireItemEnableWhenComponent,
  QuestionnaireItemOption,
  QuestionnaireItemQuestionComponent,
} from '.';
import { isTable } from './extensions';

export function isQuestionnaireItemEnableWhenHasAnwser(
  enableWhen: QuestionnaireItemEnableWhenComponent,
): enableWhen is IQuestionnaireItemEnableWhenHasAnswerComponent {
  return (
    (enableWhen as IQuestionnaireItemEnableWhenHasAnswerComponent).hasAnswer !==
    undefined
  );
}

export function isQuestionnaireItemEnableWhenBoolean(
  enableWhen: QuestionnaireItemEnableWhenComponent,
): enableWhen is IQuestionnaireItemEnableWhenBooleanComponent {
  return (
    (enableWhen as IQuestionnaireItemEnableWhenBooleanComponent)
      .answerBoolean !== undefined
  );
}

export function isQuestionnaireItemEnableWhenDecimal(
  enableWhen: QuestionnaireItemEnableWhenComponent,
): enableWhen is IQuestionnaireItemEnableWhenDecimalComponent {
  return (
    (enableWhen as IQuestionnaireItemEnableWhenDecimalComponent)
      .answerDecimal !== undefined
  );
}

export function isQuestionnaireItemEnableWhenInteger(
  enableWhen: QuestionnaireItemEnableWhenComponent,
): enableWhen is IQuestionnaireItemEnableWhenIntegerComponent {
  return (
    (enableWhen as IQuestionnaireItemEnableWhenIntegerComponent)
      .answerInteger !== undefined
  );
}

export function isQuestionnaireItemEnableWhenDate(
  enableWhen: QuestionnaireItemEnableWhenComponent,
): enableWhen is IQuestionnaireItemEnableWhenDateComponent {
  return (
    (enableWhen as IQuestionnaireItemEnableWhenDateComponent).answerDate !==
    undefined
  );
}

export function isQuestionnaireItemEnableWhenDateTime(
  enableWhen: QuestionnaireItemEnableWhenComponent,
): enableWhen is IQuestionnaireItemEnableWhenDateTimeComponent {
  return (
    (enableWhen as IQuestionnaireItemEnableWhenDateTimeComponent)
      .answerDateTime !== undefined
  );
}

export function isQuestionnaireItemEnableWhenTime(
  enableWhen: QuestionnaireItemEnableWhenComponent,
): enableWhen is IQuestionnaireItemEnableWhenTimeComponent {
  return (
    (enableWhen as IQuestionnaireItemEnableWhenTimeComponent).answerTime !==
    undefined
  );
}

export function isQuestionnaireItemEnableWhenString(
  enableWhen: QuestionnaireItemEnableWhenComponent,
): enableWhen is IQuestionnaireItemEnableWhenStringComponent {
  return (
    (enableWhen as IQuestionnaireItemEnableWhenStringComponent).answerString !==
    undefined
  );
}

export function isQuestionnaireItemEnableWhenUri(
  enableWhen: QuestionnaireItemEnableWhenComponent,
): enableWhen is IQuestionnaireItemEnableWhenUriComponent {
  return (
    (enableWhen as IQuestionnaireItemEnableWhenUriComponent).answerUri !==
    undefined
  );
}

export function isQuestionnaireItemEnableWhenAttachment(
  enableWhen: QuestionnaireItemEnableWhenComponent,
): enableWhen is IQuestionnaireItemEnableWhenAttachmentComponent {
  return (
    (enableWhen as IQuestionnaireItemEnableWhenAttachmentComponent)
      .answerAttachment !== undefined
  );
}

export function isQuestionnaireItemEnableWhenCoding(
  enableWhen: QuestionnaireItemEnableWhenComponent,
): enableWhen is IQuestionnaireItemEnableWhenCodingComponent {
  return (
    (enableWhen as IQuestionnaireItemEnableWhenCodingComponent).answerCoding !==
    undefined
  );
}

export function isQuestionnaireItemEnableWhenQuantity(
  enableWhen: QuestionnaireItemEnableWhenComponent,
): enableWhen is IQuestionnaireItemEnableWhenQuantityComponent {
  return (
    (enableWhen as IQuestionnaireItemEnableWhenQuantityComponent)
      .answerQuantity !== undefined
  );
}

export function isQuestionnaireItemEnableWhenReference(
  enableWhen: QuestionnaireItemEnableWhenComponent,
): enableWhen is IQuestionnaireItemEnableWhenReferenceComponent {
  return (
    (enableWhen as IQuestionnaireItemEnableWhenReferenceComponent)
      .answerReference !== undefined
  );
}

export function isQuestionnaireOptionString(
  option: QuestionnaireItemOption,
): option is IQuestionnaireItemOptionStringComponent {
  return (
    (option as IQuestionnaireItemOptionStringComponent).valueString !==
    undefined
  );
}

export function isQuestionnaireOptionDate(
  option: QuestionnaireItemOption,
): option is IQuestionnaireItemOptionDateComponent {
  return (
    (option as IQuestionnaireItemOptionDateComponent).valueDate !== undefined
  );
}

export function isQuestionnaireOptionInteger(
  option: QuestionnaireItemOption,
): option is IQuestionnaireItemOptionIntegerComponent {
  return (
    (option as IQuestionnaireItemOptionIntegerComponent).valueInteger !==
    undefined
  );
}

export function isQuestionnaireOptionTime(
  option: QuestionnaireItemOption,
): option is IQuestionnaireItemOptionTimeComponent {
  return (
    (option as IQuestionnaireItemOptionTimeComponent).valueTime !== undefined
  );
}

export function isQuestionnaireOptionCoding(
  option: QuestionnaireItemOption,
): option is IQuestionnaireItemOptionCodingComponent {
  return (
    (option as IQuestionnaireItemOptionCodingComponent).valueCoding !==
    undefined
  );
}

export const isQuestionnaire = (item?: any): item is IQuestionnaire => {
  return !!item && (item as IQuestionnaire).resourceType === 'Questionnaire';
};

export const isQuestionnaireGroupItem = (
  item?: any,
): item is IQuestionnaireItemGroupComponent => {
  return !!item && (item as IQuestionnaireItemGroupComponent).type === 'group';
};

export const isQuestionnaireTableGroupItem = (
  item?: any,
): item is IQuestionnaireItemTableGroupComponent => {
  return (
    !!item &&
    (item as IQuestionnaireItemGroupComponent).type === 'group' &&
    isTable(item)
  );
};

export const isQuestionnaireQuestionItem = (
  item?: QuestionnaireItemComponent,
): item is QuestionnaireItemQuestionComponent => {
  return (
    !!item &&
    (item as QuestionnaireItemComponent).type !== 'group' &&
    (item as QuestionnaireItemComponent).type !== 'display'
  );
};
